import {getEncounteredExperiments, getExperimentAssignments} from '@/utils/experiments-client'

/**
 * Builds Segment user traits from the in-memory experiment assignment:
 *   split-test-{name}: bucket
 *   split-test-encountered-{name}: 'on' | 'off'
 *   user-encountered-experiment: boolean
 */
const createTrackingForExperiments = (): Record<string, string | boolean> => {
    const assignments = getExperimentAssignments()
    const encountered = getEncounteredExperiments()

    const experiments = Object.fromEntries(
        Object.entries(assignments).map(([name, bucket]) => [`split-test-${name}`, bucket]),
    )

    const encounteredExperiments = Object.fromEntries(
        Object.entries(encountered).map(([name, value]) => [
            `split-test-encountered-${name}`,
            value ? 'on' : 'off',
        ]),
    )

    return {
        ...experiments,
        ...encounteredExperiments,
        'user-encountered-experiment': Object.values(encountered).some(Boolean),
    }
}

export default createTrackingForExperiments
